<br/>
<h5 class="card-title text-muted">Configuration</h5>
<mat-divider></mat-divider>
<mat-progress-bar *ngIf="progress"
                  [color]="'primary'"
                  [mode]="'indeterminate'">
</mat-progress-bar>
<div class="table-container">
    <div class="table-loading-shade"
         *ngIf="isLoadingResults">
        <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
    </div>

    <br/>

    <div class="table-box container">
        <div *ngFor="let item of appSettings" class="row">

            <div *ngIf="item.name == 'extractor-delta-overlap-hours'" class="col-sm-4 col-xs-12">
                <mat-form-field appearance="standard" style="width: 100%">
                    <mat-label>Extractor delta overlap (hours)</mat-label>
                    <input type="number" matInput [disabled]="progress" required [(ngModel)]="item.value">
                </mat-form-field>
            </div>

            <div *ngIf="item.name == 'reconciliation-email-enabled'" class="col-sm-4 col-xs-12">
                <label>Reconciliation email enabled</label>
                <mat-radio-group aria-labelledby="tp-radio-group-label" class="tp-radio-group"
                                 [(ngModel)]="item.value">
                    <mat-radio-button class="tp-radio-button" [value]="'true'" [disabled]="true">
                        Yes
                    </mat-radio-button>
                    <mat-radio-button class="tp-radio-button" [value]="'false'" [disabled]="true">
                        No
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="item.name == 'automap-new-provider-to-default'" class="col-sm-4 col-xs-12">
                <label>Automap new provider to default</label>
                <mat-radio-group aria-labelledby="tp-radio-group-label" class="tp-radio-group"
                                 [(ngModel)]="item.value">
                    <mat-radio-button class="tp-radio-button" [value]="'true'" [disabled]="progress">
                        Yes
                    </mat-radio-button>
                    <mat-radio-button class="tp-radio-button" [value]="'false'" [disabled]="progress">
                        No
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="item.name == 'transaction-data-source'" class="col-sm-4 col-xs-12">
                <mat-form-field style="width: 100%">
                    <mat-label>Transaction data source</mat-label>
                    <mat-select [disabled]="true" [(ngModel)]="item.value">
                        <mat-option [value]="'RED_SHIFT'">Red Shift</mat-option>
                        <mat-option [value]="'BIG_QUERY'">Big Query</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="item.name == 'prev-month-close-day'" class="col-sm-4 col-xs-12">
                <mat-form-field style="width: 100%">
                    <mat-label>Prev month close day</mat-label>
                    <mat-select [(ngModel)]="item.value" [disabled]="progress">
                        <mat-option *ngFor="let i of prevMonthDays"
                                    [value]="i">{{i}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>
        <button *ngIf="!isLoadingResults" (click)="udpate()" [disabled]="progress"
                class="btn btn-primary btn-spinner" [class.transparent-button]="progress">
            Save
        </button>
    </div>

</div>
